module.exports = __webpack_public_path__ + "static/media/House-Registration-Example.08f00514.png";